import { useSelector } from 'react-redux';
import TitleHeader from '../../components/MasterComponent/TitleHeader/TitleHeader';
import { SelectedAccount } from '../../components/SelectAccount/SelectAccount';
import { CLOUD_PROVIDER_SERVICES } from '../../utils/constants';
import { useFetchData } from '../../hooks/useFetchData';
import { config } from './config';
import { accountState } from '../../store';
import React, { useRef, useState } from 'react';
import Header from '../../components/CostBreakup/Header';
import { MultilevelHeaderTable } from '../../components/CostBreakup/MultilevelHeaderTable';
import { MIGRATION_TABS, MigrationTabs } from './costBreakupTabs';

const MigrationTransfer: React.FC<any> = () => {
  const selectedAccountInfo = useSelector(accountState);
  const [selectedTab, setSelectedTab] = useState<MigrationTabs>(MIGRATION_TABS[0]);
    const [sortColumn, setSortColumn] = useState<string>('');
    const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('desc');
    const [selectedAccountId, setSelectedAccountId] = React.useState<any>(
      selectedAccountInfo.selectedAccountId
    );
    const reqBodyRef = useRef({});
    const { fetch, data, loader: isSubmitting } = useFetchData({
      fetchData: () => config.getContainersReport(reqBodyRef.current),
  
      fetchOnMount: true,
    });
    // account selection section
    const onAccountChange = (data: any) => {
      if (data.cloudType === CLOUD_PROVIDER_SERVICES.AWS)
        setSelectedAccountId(data.accountId);
      // else if (data.cloudType === CLOUD_PROVIDER_SERVICES.AZURE) {
      //   if (data.subscriptionName) {
      //     setSelectedSubscriptionId(data.subscriptionId);
      //   } else if (data.accountId) {
      //     setSelectedAccountId(data.accountId);
      //     setSelectedSubscriptionId(ALL_VALUE);
      //   }
      // }
      setTimeout(() => {
        fetch();
      }, 0);
    };
  
    const handleTabClick = (newTab: MigrationTabs) => {
      setSelectedTab(newTab);
    };
  
    const handleSort = (column: string) => {
      const newDirection =
        sortColumn === column && sortDirection === 'desc' ? 'asc' : 'desc';
  
      setSortColumn(column);
      setSortDirection(newDirection);
    };
  
    const handleExcelDownload = () => {
      alert('Excel download feature coming soon!');
    };
  
  return (
    <div className='app-container'>
      <TitleHeader
        extraContent={<SelectedAccount onAccountChange={onAccountChange} />}
      >
        Migration & Transfer
      </TitleHeader>
       <Header
        tabs={[...MIGRATION_TABS]}
        selectedTab={selectedTab}
        onTabChange={handleTabClick}
        showMonthFilter
        showExcelDownload
        onDownload={handleExcelDownload}
        isDownloading={false}
      />
      <MultilevelHeaderTable
        loading={false}
        sortedEntries={[]}
        onSort={handleSort}
        columns={[]}
        summableColumns={[]}
        sortColumn={sortColumn}
        sortDirection={sortDirection}
      />
    </div>
  );
};

export default MigrationTransfer;
